import { connect } from 'react-redux'
import UserDetailsSubs from './user-details-subs'
import {
  getUser,
  getUpdateAccountRequest
} from '../../../../../stores/user-details/user-details.selectors'
import { format } from 'date-fns'
import { withRouter } from 'react-router'
import { createSubscription } from '../../../../../stores/user-details/user-details.actions'
import { withMe } from 'pobble-components/dist/pobble-user'
import { toast } from 'pobble-components/dist/toast'

const mapStateToProps = (state, { me }) => {
  const user = getUser(state)
  const updateAccountDetails = getUpdateAccountRequest(state)
  return {
    pending: updateAccountDetails.pending,
    subsPlan: user.individual_subscription && user.individual_subscription.plan,
    subsPlanMkt:
      user.individual_subscription &&
      user.individual_subscription.plan_marketing_name,
    subsStatus:
      user.individual_subscription && user.individual_subscription.status,
    subsEnd:
      user.individual_subscription &&
      user.individual_subscription.period_end &&
      format(user.individual_subscription.period_end, 'YYYY-MM-DD')
  }
}

const mapDispatchToProps = (dispatch, { match, me }) => ({
  onSubmit: values => {
    const data = {
      end_time: values.endDate,
      plan_type: values.plan
    }
    dispatch(createSubscription(match.params.id, data))
      .then(toast.success('Subscription successfully updated'))
      .catch(e =>
        toast.error(
          (e.response.data.errors && e.response.data.errors[0].msg) ||
            'Something went wrong'
        )
      )
  }
})

export default withMe(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(UserDetailsSubs))
)
